import toastr from "toastr";

export const toastrSuccess = (message) => {
  //toastr.success(message);
};

export const toastrError = (message) => {
  toastr.error(message);
};
